__turbopack_context__.v({
  "BGPattern": "Header-module-scss-module__5aonbq__BGPattern",
  "button": "Header-module-scss-module__5aonbq__button",
  "header": "Header-module-scss-module__5aonbq__header",
  "headerContent": "Header-module-scss-module__5aonbq__headerContent",
  "headerContentButton": "Header-module-scss-module__5aonbq__headerContentButton",
  "headerContentImages": "Header-module-scss-module__5aonbq__headerContentImages",
  "headerContentImagesEn": "Header-module-scss-module__5aonbq__headerContentImagesEn",
  "headerContentTitle": "Header-module-scss-module__5aonbq__headerContentTitle",
  "headerContentTitleText": "Header-module-scss-module__5aonbq__headerContentTitleText",
  "headerContentTitleTextMain": "Header-module-scss-module__5aonbq__headerContentTitleTextMain",
  "iconMessage": "Header-module-scss-module__5aonbq__iconMessage",
  "pulse": "Header-module-scss-module__5aonbq__pulse",
  "reestr": "Header-module-scss-module__5aonbq__reestr",
});
